import type { ComponentProps } from 'react';

import TableView from 'pages/PlanPageDetailsOPZ/ItemPage/DesktopPanel/TableView';

import { PlanRevampTableProvider } from '../PlanRevampTableContext';
import '../planRevampDriverTable.scss';

type TableViewProperties = ComponentProps<typeof TableView>;

const RevampDriverTableView = (properties: Omit<TableViewProperties, 'variant'>) => (
  <PlanRevampTableProvider>
    <TableView {...properties} variant='revamp' />
  </PlanRevampTableProvider>
);

export default RevampDriverTableView;
